export default {
  styleOverrides: {
    root: {
      color: 'var(--color-text-primary)',
      padding: '8px',
      borderRadius: '8px',
      transition: 'background-color 0.15s ease',

      '&:hover': {
        backgroundColor: 'var(--color-action-hover)',
      },

      '&.Mui-selected': {
        backgroundColor: 'var(--color-primary)',
        color: 'var(--color-primary-contrast)',

        '&:hover': {
          backgroundColor: 'var(--color-primary-dark)',
        },
      },

      '&.Mui-focusVisible': {
        backgroundColor: 'var(--color-primary)',
        color: 'var(--color-primary-contrast)',
      },

      '&.Mui-disabled': {
        backgroundColor: 'var(--color-action-disabled-bg)',
        color: 'var(--color-text-disabled)',
      },
    },
  },
};
